import { FilePdfOutlined } from "@ant-design/icons";
import pdf from "@react-pdf/renderer";
import { Button } from "antd";
import React from "react";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
import IndexesByCategoryDataReportPDFTemplate from "./IndexesByCategoryDataReportPDFTemplate";

const { PDFDownloadLink } = pdf;
export interface Props {
  translate: any;
  date?: Date;
  selectedCategory?: IOrganisationIndexCategory;
  data: any;
  fileName: string;
}

export interface State {
  ready: boolean;
}

export default class PDFExportIndexesByCategoryDataReport extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props, ready: false };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data } = this.props;
    if (data !== prevProps?.data) {
      this.setState({
        ready: false
      });
    }
  }

  toggle() {
    this.setState(
      (prevState) => ({
        ready: false
      }),
      () => {
        setTimeout(() => {
          this.setState({ ready: true });
        }, 1);
      }
    );
  }

  render() {
    const { ready } = this.state;
    const { translate, data, fileName, date, selectedCategory } = this.props;
    return (
      <div>
        {ready && (
          <PDFDownloadLink
            document={
              <IndexesByCategoryDataReportPDFTemplate
                translate={translate}
                data={data}
                selectedCategory={selectedCategory}
                date={date}
              />
            }
            fileName={fileName}
          >
            {({ blob, url, loading, error }) =>
              loading ? (
                translate("reports.pdf.loading")
              ) : (
                <FilePdfOutlined style={{ fontSize: 20, color: "#ED1C24" }} />
              )
            }
          </PDFDownloadLink>
        )}
        {!ready && (
          <Button size={"small"} onClick={() => this.toggle()}>
            {translate("reports.pdf.generate_pdf")}
          </Button>
        )}
      </div>
    );
  }
}
